import { WorkawareApi } from 'apis/WorkawareApi'
import { ScheduledEventTypeDto } from 'data/dtos/ScheduledEventTypeDto'
import { ScheduledStatusTypeDto } from 'data/dtos/ScheduledStatusTypeDto'
import { ScheduledVisibilityTypeDto } from 'data/dtos/ScheduledVisibilityTypeDto'

export class scheduledItemSettingsService {
  private _api: WorkawareApi

  constructor(api: WorkawareApi) {
    this._api = api
  }

  getAllEventTypes = () => new Promise<ScheduledEventTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.eventTypes.get()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  activeEventTypes = () => new Promise<ScheduledEventTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.eventTypes.getActive()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  postEventType = (item: ScheduledEventTypeDto) => new Promise<ScheduledEventTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.eventTypes.post(item)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })

  deleteEventType = (id: string) => new Promise<ScheduledEventTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.eventTypes.delete(id)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })

  getAllStatusTypes = () => new Promise<ScheduledStatusTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.statusTypes.get()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  activeStatusTypes = () => new Promise<ScheduledStatusTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.statusTypes.getActive()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  postStatusType = (item: ScheduledStatusTypeDto) => new Promise<ScheduledStatusTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.statusTypes.post(item)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })

  deleteStatusType = (id: string) => new Promise<ScheduledStatusTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.statusTypes.delete(id)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })

  getAllVisibilityTypes = () => new Promise<ScheduledVisibilityTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.visibilityTypes.get()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  activeVisibilityTypes = () => new Promise<ScheduledVisibilityTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.visibilityTypes.getActive()
      .then(result => resolve([...result].reverse()))
      .catch(error => reject(error))
  })

  postVisibilityType = (item: ScheduledVisibilityTypeDto) => new Promise<ScheduledVisibilityTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.visibilityTypes.post(item)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })

  deleteVisibilityType = (id: string) => new Promise<ScheduledVisibilityTypeDto[]>((resolve, reject) => {
    this._api.scheduledItemSettings.visibilityTypes.delete(id)
      .then(result => resolve(result))
      .catch(error => reject(error))
  })
}
